import { SVButton, SVLoader, SVTabs } from '@/components/core';
import ExternalAccountsList from '@/components/externalAccounts/ExternalAccountsList';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetExternalAccountsList } from '@/hooks/requests/useExternalAccounts';
import { ExternalBankAccountStatus } from '@/types/externalAccounts';
import { Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ExternalAccountsListPage() {
  const navigate = useNavigate();
  const { aggregateInfo, externalAccountsIsPending } =
    useGetExternalAccountsList();

  if (externalAccountsIsPending) {
    return (
      <DefaultLayout header="External Accounts">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header="External Accounts"
      buttons={[
        <SVButton
          key="add"
          onClick={() => navigate(ROUTES.EXTERNAL_ACCOUNTS_ADD)}>
          Add
        </SVButton>,
      ]}>
      <Card>
        <SVTabs
          headers={[
            `Awaiting E-Sign (${aggregateInfo?.totalAwaitingESign || 0})`,
            `Submitted (${aggregateInfo?.totalSubmitted || 0})`,
            `Verified (${aggregateInfo?.totalVerified || 0})`,
            `Declined (${aggregateInfo?.totalDeclined || 0})`,
          ]}
          panels={[
            <ExternalAccountsList
              key="pending"
              status={ExternalBankAccountStatus.AWAITING_E_SIGN}
            />,
            <ExternalAccountsList
              key="submitted"
              status={ExternalBankAccountStatus.SUBMITTED}
            />,
            <ExternalAccountsList
              key="verified"
              status={ExternalBankAccountStatus.VERIFIED}
            />,
            <ExternalAccountsList
              key="declined"
              status={ExternalBankAccountStatus.DECLINED}
            />,
          ]}
        />
      </Card>
    </DefaultLayout>
  );
}
